import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	unassignedVersionName: {
		id: 'software-filters.version-filter-relay.unassigned-version-name',
		defaultMessage: 'Issues without version',
		description:
			'The label for the option in the version filter to select issues that do not have any versions assigned',
	},
});
